'use client';

import { Toaster } from '@/components/ui/sonner';
import { TooltipProvider } from '@/components/ui/tooltip';
import { ThemeProvider } from 'next-themes';
import NextTopLoader from 'nextjs-toploader';

export default function Providers({ children }: { children: React.ReactNode }) {
  return (
    <>
      <TooltipProvider>
        <ThemeProvider
          attribute="class"
          defaultTheme="system"
          enableSystem
          disableTransitionOnChange
        >
          <NextTopLoader
            easing="ease"
            showSpinner={false}
            color="var(--primary)"
          />
          {children}
          <Toaster position="top-center" />
        </ThemeProvider>
      </TooltipProvider>
    </>
  );
}
